import Joi from 'joi';
import { ProductType } from 'constants.js';

const details = {
  name: Joi.string()
    .label('Attachment Name')
    .min(3)
    .max(100)
    .required(),
  type: Joi.string()
    .label('Attachment Type')
    .required(),
  // ...automationOptionsValidation
  campaignOccurrenceType: Joi.string()
    .allow('')
    .optional()
    .label('Automation'),
  promotional: Joi.boolean()
    .required()
    .label('Promotional Campaign'),
  surveyResponseTemplate: Joi.boolean()
    .required()
    .label('Survey Response Template'),
  productName: Joi.string()
    .label('Product Type')
    .required(),
  subscriberListId: Joi.when('productType', {
    is: ProductType.List,
    then: Joi.string()
      .label('Subscribers List')
      .required()
  }),
  schemaIdentifier: Joi.string()
    .label('Event Type')
    .required()
};

const design = {
  id: Joi.string(),
  jsonContent: Joi.any()
};

export default {
  details,
  design,
  all: {
    ...design,
    ...details
  }
};
